import { api } from '../../axios.instance';

export const exportResidents = () => {
  return api.get('/residents/export', { responseType: 'blob' });
};
